import {
  fetchUserCouponTotalCount,
  formatCouponIsoLocalDateTime,
} from "@/api/coupon-user";
import { COUPON_USER_STATUS_AVAILABLE } from "./normalizeUserCoupon";

/**
 * 未使用优惠券数量：status=AVAILABLE 且未过期（expireAtFrom=当前时刻）。
 */
export async function fetchUnusedCouponCount({ tenantId, userId }, axiosConfig = {}) {
  if (userId == null || userId === "") {
    return { ok: true, count: 0 };
  }
  const nowIso = formatCouponIsoLocalDateTime(new Date());
  const { ok, totalCount, mc } = await fetchUserCouponTotalCount(
    {
      tenantId,
      userId: String(userId),
      status: COUPON_USER_STATUS_AVAILABLE,
      ...(nowIso ? { expireAtFrom: nowIso } : {}),
    },
    axiosConfig
  );
  const n = ok && totalCount != null ? Number(totalCount) : 0;
  return {
    ok,
    count: Number.isFinite(n) && n > 0 ? n : 0,
    mc,
  };
}
